import { defineStore } from 'pinia'
import ChangePasswordStore, { ChangePasswordState } from '@/modules/changePassword/types/store/ChangePasswordStore'

export const useChangePasswordStore: ChangePasswordStore = defineStore('changePassword', {
  state: () => ({}) as ChangePasswordState,
  getters: {},
  actions: {
    async updateUserPassword(data) {
      const response = await this.$services.changePassword.updateUserPassword(data)
      if (response instanceof Error) {
        return response
      }
    },
  },
})
